import { isBulkActionRunning } from 'owa-bulk-action-store';
export default function getCanTableLoadMore(tableView) {
    // If bulk operation is running in this folder, do not load more
    if (isBulkActionRunning(tableView.serverFolderId)) {
        return false;
    }
    // We have more items in the store locally outside of loaded range, so we can load more
    if (tableView.currentLoadedIndex < tableView.rowKeys.length) {
        return true;
    }
    // If we have no more items locally in store, check if there are more items on server
    // We can only support load more SeekToCondition request if we have any items left on the client
    // VSO 12854: Listview should load more if user deletes all items that's on the client but the server has more rows
    return tableView.rowKeys.length > 0 && tableView.rowKeys.length < tableView.totalRowsInView;
}
//# sourceMappingURL=getCanTableLoadMore.js.map